import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
function check_webp_feature(feature, callback) {
  var kTestImages = {
    lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
    lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
    alpha:
      "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
    animation:
      "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
  };
  var img = new Image();
  img.onload = function () {
    var result = img.width > 0 && img.height > 0;
    callback(feature, result);
  };
  img.onerror = function () {
    callback(feature, false);
  };
  img.src = "data:image/webp;base64," + kTestImages[feature];
}

export const WebpSupportContext = createContext({
  lossy: false,
  lossless: false,
  alpha: false,
  animation: false,
});

export function useWebpSupport() {
  const support = useContext(WebpSupportContext);

  return support;
}

export const WebpSupport = ({ children }) => {
  const [result, setResult] = useState(null);

  async function detectSupport() {
    const promises = ["lossy", "lossless", "alpha", "animation"].map(
      (feature) =>
        new Promise((resolve) =>
          check_webp_feature(feature, (_, result) => resolve(result))
        ).then((isSupported) => ({
          feature,
          isSupported,
        }))
    );

    const features = await Promise.all(promises);

    return features.reduce(
      // eslint-disable-next-line no-sequences
      (acc, { feature, isSupported }) => ((acc[feature] = isSupported), acc),
      {}
    );
  }

  const detectSupportMemoized = useMemo(detectSupport, []);

  useEffect(() => {
    detectSupportMemoized.then(setResult);
  }, [detectSupportMemoized]);

  if (!result) return null;

  return (
    <WebpSupportContext.Provider value={result}>
      {children}
    </WebpSupportContext.Provider>
  );
};

export default WebpSupport;
